<div class="widget-container" #PixelMapDiv>
    <app-pixel-map [headerConfig]="item.config?.widget_header_configuration" [config]="config" [data]="data"
        [parentData]="parentData" [item]="item" [pageKey]="pageKey" [totalRecords]="totalRecords"
        [dataStartIndex]="currentStartIndex" (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)" (filterQueryChange)="onFilterQueryChange($event)"
        [isLoading]="isChildPageLoading" (serverSideSearch)="serverSideSearch($event)" [error_name]="error_name"
        [makeYAxisLinks]="true">
    </app-pixel-map>
</div>